/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Readonly_ToastInputs */

const en_lifecycle_readonly_toast = /** @type {(inputs: Lifecycle_Readonly_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived products are read-only. Unarchive the product to make changes.`)
};

const de_lifecycle_readonly_toast = /** @type {(inputs: Lifecycle_Readonly_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivierte Produkte sind schreibgeschützt. Hole das Produkt aus dem Archiv, um etwas zu ändern.`)
};

/**
* | output |
* | --- |
* | "Archived products are read-only. Unarchive the product to make changes." |
*
* @param {Lifecycle_Readonly_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_readonly_toast = /** @type {((inputs?: Lifecycle_Readonly_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Readonly_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_readonly_toast(inputs)
	return en_lifecycle_readonly_toast(inputs)
});